import template from './selectTree.html'

export default function selectTreeDirective() {
    return {
        restrict: 'E',
        // 指令比较重要的 scope属性实现与控制器作用域的隔离与交互，反正就是作用域不影响而又可以传参交互
        scope: {
            // tree-model="fnTree" on-selection="onSelected(node)" on-collapse="onCollapse(node)"
            treeModel: '=', // 这里接受外部的参数 并且实现与外部参数的双向数据交互
            onSelection: '&',
            onCollapse: '&',
            stChange: '=',
        },
        template,
        // link complir 这些函数少许区别 可以看下指令api 说明
        compile(scope, element, attrs, link) {
            return function (scope, element, attrs) {
                const $collapseBox = $('.collapse-box')

                scope.collapse = function (e) {
                    const _this = e.target
                    if (_this.className.indexOf('j-nocollapse') === -1 || _this.parentNode.className.indexOf('j-nocollapse') === -1) {
                        const $collapseTop = $(e.delegateTarget)
                        const $collapseBtn = $('.collapseBtn', $collapseTop)
                        if ($collapseBtn.hasClass('icon-shouqi1')) {
                            $collapseBtn.removeClass('icon-shouqi1').addClass('icon-zhankai2')
                        } else {
                            $collapseBtn.removeClass('icon-zhankai2').addClass('icon-shouqi1')
                        }
                        $collapseTop.next('.collapse-content').slideToggle('fast')
                    }
                }

                var recursionChild = function (childNodes, parentNode, cb) {
                    for (const i in childNodes) {
                        cb(childNodes[i], parentNode)
                        if (childNodes[i].childFuncList) {
                            recursionChild(childNodes[i].childFuncList, childNodes[i], cb)
                        }
                    }
                }


                scope.onSelect = function (node, parentNodes) {
                // 临时处理需求--常用菜单设置应该最多设置9个常用三级菜单，超过9个则不允许勾选
                    scope.stChange && scope.stChange(node, parentNodes)
                    // var flag = node.selected;
                    // var childNode = node.childFuncList;
                    //  //全选取消 通知 下级
                    // if(childNode) {
                    //     recursionChild(childNode,node,(item) => {
                    //             item.selected = flag;
                    //     })
                    // }
                    // //迭代同级 冒泡通知上级
                    // if(parentNodes) {

                    //     for(var p in parentNodes ) {
                    //         var selectedCount = 0;
                    //         var siblingNodes = parentNodes[p].childFuncList.length;
                    //         recursionChild(parentNodes[p].childFuncList,parentNodes[p],(item,parentNode) =>{
                    //             //统计
                    //             if(item.selected == true) {
                    //                 selectedCount++;
                    //             }
                    //         });
                    //         if(selectedCount == siblingNodes ) {
                    //             parentNodes[p].selected = true;
                    //         } if( selectedCount > 0 ) {
                    //             parentNodes[p].selected = true;
                    //         } else {
                    //             parentNodes[p].selected = false;
                    //         }

                    //     }

                // }
                }
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/selectTree2/selectTreeDirective.js